import { Container, Reveal } from '@/components/common'
import heroBg from '@/assets/images/networking-desk.jpeg'

export const ContactHero = () => {
  return (
    <section className="relative isolate overflow-hidden bg-ibon-dark">
      <div
        className="absolute inset-0 -z-20 bg-cover bg-center"
        style={{ backgroundImage: `url(${heroBg})` }}
        aria-hidden
      />
      <div className="absolute inset-0 -z-10 bg-ibon-dark/85" />
      <div className="absolute inset-0 -z-10 bg-linear-to-b from-ibon-dark/60 via-transparent to-ibon-dark" />

      <Container className="py-28 lg:py-40">
        <Reveal variant="up" delay={100}>
          <h1 className="mt-8 max-w-5xl text-4xl font-bold leading-[1.03] tracking-[-0.02em] text-white sm:text-5xl lg:text-7xl">
            Get in touch <span className="text-white/40">with our team.</span>
          </h1>
        </Reveal>

        <Reveal variant="up" delay={220}>
          <p className="mt-9 max-w-3xl text-lg leading-relaxed text-white/75">
            We welcome inquiries from{' '}
            <span className="font-semibold text-white">
              partners, sponsors, donors, volunteers, educational institutions, and government
              agencies
            </span>{' '}
            as well as members of the public who share our vision for Africa and the Caribbean.
          </p>
        </Reveal>
      </Container>
    </section>
  )
}
